import * as gs from "@ivanlog/gs";
import { AppControllerBase } from "./AppControllerBase";
import { CmpModalDialog } from "../com/CmpModalDialog";
import { LayoutMain } from "../com/tmpls";
import { IApp } from "../IApp";

export class GUIControllerBase extends AppControllerBase {

    private readonly _container: gs.WrapperGS;

    private _page: gs.TemplateGS;
    private _body: gs.WrapperGS;
    private _layout:LayoutMain;

    public get layoutMain() {return this._layout;}

    constructor(app: IApp) {
        super(app);
        this._body = gs.q('body').first;
        this._layout= new LayoutMain();
        this._container = this._layout;
        this._body.prepend(this._layout);
    }

    public async startAsync()
    {
        await this._layout.ctrls.cmpHeader.initAsync()
        this._layout.ctrls.lVersion.text=this._app.version;
    }

    public setFooter(footer:gs.WrapperGS)
    {
        this._layout.ctrls.footer.html='';
        this._layout.ctrls.footer.append(footer);
    }

    public showPage(page: gs.TemplateGS) {        
        if (this._page) this._page.cut();
        this._page = page;
        this._layout.ctrls.pageContainer.append(page);       
        page.show();
    }
    public hidePage() {
        if (!this._page) return;
        this._page.cut();
        this._page = undefined;
    }

    private _lockCounter = 0;
    public lock() {
        if (this._lockCounter === 0) this._container.disable();
        this._lockCounter++;
    }
    public unlock() {
        if (this._lockCounter <= 0) return;
        this._lockCounter--;
        if (this._lockCounter === 0) this._container.enable();
    }
    public async lockActionAsync<T>(action: Promise<T>) {
        this.lock();
        try {
            return await action;
        } finally {
            this.unlock();
        }
    }

    public getTxLockText()
    {
        return this._layout.ctrls.lTxLock.text;
    }

    public setTxLockText(text:string)
    {
        this._layout.ctrls.lTxLock.text=text;
    }

    public async awaitInLockUIAsync(promise:Promise<any>):Promise<any>
    {
        this._layout.ctrls.cmpTxLock.show();
        try { 
            const result = await promise;
            this._layout.ctrls.cmpTxLock.hide();
            return result;
        }
        catch (error)
        {
            this._layout.ctrls.cmpTxLock.hide();
            throw error;
        }
    }

    public async dialogOkShowAsync(message:string, title?:string):Promise<boolean|undefined>
    {
        return CmpModalDialog.DialogOk(message, title).showAndWaitAsync();
    }

    public async dialogOkNoShowAsync(message:string, title?:string):Promise<boolean|undefined>
    {
        return CmpModalDialog.DialogOkNo(message, title).showAndWaitAsync();
    }

    public dialogOkCreate(message?:string, title?:string):CmpModalDialog
    {
        return CmpModalDialog.DialogOk(message, title);
    }
}
